var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"err"},[_vm._v("404")]),_c('div',{staticClass:"msg"},[_vm._v("Looks like you reached a page that does not exist!"),_c('p',[_vm._v("Let's go "),_c('a',{on:{"click":_vm.goHome}},[_vm._v("home")]),_vm._v(" and try from there.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }